import React from "react";
import OtifReport from "../../../common/reports/otif";

const OtifIndex = props => {
  return <OtifReport collabType="CMO" {...props} />;
};

export default OtifIndex;
